import ScreenshotActions from './screenshot-actions';
import ScreenshotOverlay from './screenshot-overlay';

export default class BoardsTrialAction extends ScreenshotActions {
    static taskName = 'Update Logo for Version 2';
    static boardName = 'Completed';
    static hash = 'screenshot_boards__button_form';

    constructor(screenshot, event, type, onAdd, onRemove, onSuccess) {
        super(screenshot, event, type, onAdd, onRemove, onSuccess);
        this.$modal = $('#modal-pro');
        this.$form = this.$modal.find('form');
        this.$formHash = this.$form.data('hash');
        this.overlay = null;

        this.$modal.on('hide.wg.modal', () => {
            this.$form.data('hash', this.$formHash);
        });

        WG.Observable.fromEvent(this.$form.wgInstance().$element.eq(0), 'success.wg.registration').subscribe(() => {
            if (this.overlay && this.$form.data('hash') === BoardsTrialAction.hash) {
                this.overlay.hide();
                this.stopTracking();
            }
        });
    }

    validate() {
        return this.details.task === BoardsTrialAction.taskName && this.details.board === BoardsTrialAction.boardName;
    }

    execute() {
        this.overlay = new ScreenshotOverlay(this.screenshot, this.onClick.bind(this));
        this.overlay.init().show();
    }

    onClick() {
        this.$form.data('hash', BoardsTrialAction.hash);
        this.$modal.wgInstance().show();
    }
}



// WEBPACK FOOTER //
// ./assets/js/projects/home-enterprise/screenshots/boards-trial.js